import React from 'react';
import styled from 'styled-components';
import {CONSTS} from './_constants';
import { useHistory } from 'react-router';

type cardComponentProps = {
    className?:string,
    back?: boolean,
    title?: string,
    headerMeta?: any,
    children?: any,
    goBack?: Function
}
const CardComponent = (props: cardComponentProps) => {
    let history = useHistory();
    const goBack = () => {
        if(props.goBack) {
            props.goBack();
            return
        }
        history.goBack();
    }
    return(
        <div className={props.className}>
            {(props.back || props.title || props.headerMeta) && <div className="_header">
                <h2 className="_title">{props.title}</h2>
                <div className="_meta">
                    {props.headerMeta}
                    {props.back && <div onClick={goBack} className="_back">
                        بازگشت
                    </div>}
                </div>
            </div>}

            {props.children &&<div className="_body">{props.children}</div>}
            
        </div>
    )}

const Card = styled(CardComponent)`
    background: #FFFFFF;
    border: 1px solid rgba(63,63,68,0.05);
    border-radius: ${CONSTS.border.radius2};
    overflow:hidden;
    > ._header{
        ${props => props.children ? "border-bottom: 1px solid rgba(63,63,68,0.05);" : ""}
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        height: 53px;
        > ._title{
            font-family: ${CONSTS.fonts.primary.bold};
            font-size: 16px;
            color: ${CONSTS.colors.primary};
            padding-right: 20px;
        }
        > ._back{

        }
        > ._meta{
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-end;
        }
    }
    > ._body{
        overflow: auto;
    }
    @media only screen and (max-width: ${CONSTS.responsiveSizes.small}) {
        border-radius: 0;
        > ._header{
            > ._title{
                font-size: 13px;
                font-weight: 500;
            }
        }
`

export default Card;